import { render, staticRenderFns } from "./parkDetailCopy.vue?vue&type=template&id=5507863f&scoped=true"
import script from "./parkDetailCopy.vue?vue&type=script&lang=js"
export * from "./parkDetailCopy.vue?vue&type=script&lang=js"
import style0 from "./parkDetailCopy.vue?vue&type=style&index=0&id=5507863f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5507863f",
  null
  
)

export default component.exports